import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import { getBoxShadowStyle } from '@styles/shadow';

import Image from '@components/common/Image';
import TouchableElement from '@components/common/touchableElement';
import ItemHistoryTime from '@components/common/ItemHistoryTime';
import { isPhone } from '@helpers';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

const Item = ({ C, item, isFirst, isLast, generateImageURL, maxValueProductive, maxValueActive }) => {
  const [imageLink, setImageLink] = useState(null);
  const { imageData, imageHash, fullName } = item;

  useEffect(() => {
    (async () => {
      if (imageHash) {
        const imageLink = await generateImageURL({
          size: '_1x',
          cropped: imageData?.isCropped,
          item: { imageHash: imageHash, extensionDerivative: imageData?.extensionDerivative },
          page: imageData?.pageNumber,
        });
        setImageLink(imageLink);
      }
    })();
  }, []);

  return (
    <View
      style={[
        {
          paddingLeft: scale(18),
          backgroundColor: C('Background/Dark/Field'),
        },
        isFirst && { borderTopLeftRadius: scale(SCREEN_BORDER_RADIUS), borderTopRightRadius: scale(SCREEN_BORDER_RADIUS) },
        isLast && { borderBottomLeftRadius: scale(SCREEN_BORDER_RADIUS), borderBottomRightRadius: scale(SCREEN_BORDER_RADIUS) },
      ]}
    >
      <View
        style={[
          {
            height: scale(80),
            flexDirection: 'row',
            borderBottomWidth: isLast ? 0 : StyleSheet.hairlineWidth,
            borderColor: C('Hairline/Dark/No trans'),
            alignItems: 'center',
          },
        ]}
      >
        <View>
          <Image
            {...{
              shadowColor: 'transparent',
              isShadow: Boolean(imageLink),
              isOverlay: true,
              resizeMode: 'contain',
              style: {
                width: scale(90),
                height: scale(60),
                resizeMode: 'contain',
              },
              source: { uri: imageLink },
              alt: 'img',
              C,
            }}
          />
        </View>
        <View style={{ height: '100%', paddingVertical: scale(7), paddingHorizontal: scale(18), flex: 1 }}>
          <Text style={[font['Button 1'], { color: C('Label/Dark/Primary') }]} numberOfLines={1}>
            {fullName}
          </Text>
          <View>
            <ItemHistoryTime
              {...{
                C,
                paddingLeft: 0,
                maxWidth: isPhone ? 70 : 80,
                item: { machineStatistics: { ...item, totalLoaded: true }, maxValueProductive, maxValueActive },
              }}
            />
          </View>
        </View>
      </View>
    </View>
  );
};

export default ({ C, machineStatisticsForNCFile, generateImageURL }) => {
  return (
    <View style={{ marginTop: scale(28), paddingBottom: scale(100) }}>
      <View style={{ paddingHorizontal: scale(15), marginBottom: scale(5) }}>
        <Text style={[font.Footnote, { color: C('Label/Light/Tertiary') }]}>{i18n.t('MOST PRODUCTIVE MACHINES FOR THIS NC FILE')}</Text>
      </View>
      <View style={[getBoxShadowStyle({ type: 'Field' }), { borderRadius: scale(SCREEN_BORDER_RADIUS) }]}>
        {machineStatisticsForNCFile.data.map((item, index) => {
          const isFirst = index === 0;
          const isLast = index === machineStatisticsForNCFile.data.length - 1;
          return (
            <Item
              key={item.ncFileId}
              {...{
                C,
                item,
                index,
                generateImageURL,
                isFirst,
                isLast,
                maxValueActive: machineStatisticsForNCFile.maxValueActive,
                maxValueProductive: machineStatisticsForNCFile.maxValueProductive,
              }}
            />
          );
        })}
      </View>
    </View>
  );
};
